module.exports = __webpack_public_path__ + "d105e29fcf233fccff11f1b50b57abc8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-6.png
// module id = 2050
// module chunks = 0